<template>
  <div class="dialog-content">
    <el-form
      :rules="rules"
      :model="autoPartsformData"
      ref="autoPartsform"
      class="demo-ruleForm"
      label-width="100px"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="配件编码" prop="Code">
            <el-input v-model.trim="autoPartsformData.Code" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="配件名称" prop="Cn">
            <el-input v-model.trim="autoPartsformData.Cn" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="英文名称" prop="En">
            <el-input v-model.trim="autoPartsformData.En" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="单位" prop="Unit">
            <el-input v-model.trim="autoPartsformData.Unit" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="尺寸" prop="Size">
            <el-input v-model="autoPartsformData.Size" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="重量(kg)" prop="Weight">
            <el-input v-model.trim="autoPartsformData.Weight" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="互换码" prop="ChangeCode">
            <el-input v-model.trim="autoPartsformData.ChangeCode" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="别称" prop="Alias">
            <el-input v-model.trim="autoPartsformData.Alias" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="可用时间(天)" prop="DurationAdvice">
            <el-input v-model.trim="autoPartsformData.DurationAdvice" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label=" 可跑里程(km)" prop="KilometerAdvice">
            <el-input v-model.trim="autoPartsformData.KilometerAdvice" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="适用车型" prop="VehicleDesc">
        <el-input v-model.trim="autoPartsformData.VehicleDesc" maxlength="500"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="Memo">
        <el-input v-model.trim="autoPartsformData.Memo" type="textarea" maxlength="500"></el-input>
      </el-form-item>
      <el-tabs type="border-card" v-model="activeName" lable-width="100px" style="min-height:428px">
        <el-tab-pane label="配件品牌" name="brands_pane">
          <el-form :inline="true" :model="brandsTemp" @submit.native.prevent>
            <el-form-item label="名称">
              <el-input v-model="brandsTemp.name" size="small"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="getBrandsList">查找</el-button>
            </el-form-item>
          </el-form>
          <el-row :gutter="20">
            <el-col :span="11">
              <div style="padding-bottom:5px;height:19px;">
                <label></label>
              </div>
              <el-table
                ref="brandsTable"
                v-loading="listLoading"
                :data="brandsList"
                border=""
                fit
                highlight-current-row
                @selection-change="brandLeftSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="品牌">
                  <template slot-scope="{row}">
                    <span>{{ row.Name }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="1" style="text-align:center;margin-top: 35px;">
              <el-button
                type="primary"
                :disabled="!brandsData.length"
                icon="el-icon-arrow-right"
                size="small"
                circle
                @click="addBrands()"
              ></el-button>
              <el-button
                type="primary"
                :disabled="!selectedbrandsData.length"
                icon="el-icon-arrow-left"
                circle
                style="margin-left: 0;margin-top: 10px;"
                size="small"
                @click="removeBrands()"
              ></el-button>
            </el-col>
            <el-col :span="11">
              <div style="padding-bottom:5px;color:#909399;text-align:right;">
                <label>已选择品牌</label>
              </div>
              <el-table
                ref="selectedbrandsTable"
                :data="selectedbrandsList"
                border=""
                fit
                highlight-current-row
                @selection-change="brandRightSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="品牌">
                  <template slot-scope="{row}">
                    <span>{{ row.Name }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="适用车型" name="autoSeries_pane">
          <el-form :inline="true" :model="autoSeriesTemp" @submit.native.prevent>
            <el-form-item label="年款">
              <el-input-number
                v-model="autoSeriesTemp.s_num"
                :min="1900"
                :precision="0"
                controls-position="right"
                size="small"
              ></el-input-number>
              <el-input-number
                v-model="autoSeriesTemp.e_num"
                :min="1900"
                controls-position="right"
                size="small"
                style="margin-left:10px;"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="关键词">
              <el-input v-model="autoSeriesTemp.name" size="small" placeholder="车型或品牌"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="getAutoSeriesList(1)">查找</el-button>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="11">
                <div style="padding-bottom:5px;height:19px;">
                  <label></label>
                </div>
                <el-table
                  ref="suppliersTable"
                  v-loading="listLoading"
                  :data="autoSeriesList"
                  border=""
                  fit
                  highlight-current-row
                  @selection-change="autoSeriesLeftSelectionChange"
                >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column label="年款">
                    <template slot-scope="{row}">
                      <span>{{ row.ModelYear }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="车型">
                    <template slot-scope="{row}">
                      <span>{{ row.Cn==""?row.En: row.Cn}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="档次版本">
                    <template slot-scope="{row}">
                      <span>{{ row.LevelVer }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="档位类型">
                    <template slot-scope="{row}">
                      <span>{{ row.GearType }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="排量版本">
                    <template slot-scope="{row}">
                      <span>{{ row.EmissionVer }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="品牌">
                    <template slot-scope="{row}">
                      <span>{{ row.BrandCn==""?row.BrandEn:row.BrandCn }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  layout="prev, pager, next"
                  :current-page.sync="autoSeriesTemp.currentPage"
                  :total="autoSeriesTemp.totalCount"
                  @current-change="getAutoSeriesList"
                ></el-pagination>
              </el-col>
              <el-col :span="1" style="text-align:center;margin-top: 35px;">
                <el-button
                  type="primary"
                  :disabled="!autoSeriesData.length"
                  icon="el-icon-arrow-right"
                  size="small"
                  circle
                  @click="addAutoSeries()"
                ></el-button>
                <el-button
                  type="primary"
                  :disabled="!selectedAutoSeriesData.length"
                  icon="el-icon-arrow-left"
                  circle
                  style="margin-left: 0;margin-top: 10px;"
                  size="small"
                  @click="removeAutoSeries()"
                ></el-button>
              </el-col>
              <el-col :span="11">
                <div style="padding-bottom:5px;color:#909399;text-align:right;">
                  <label>已选择车型</label>
                </div>
                <el-table
                  ref="selectedSuppliersTable"
                  :data="selectedAutoSeriesList"
                  border=""
                  fit
                  highlight-current-row
                  @selection-change="autoSeriesRightSelectionChange"
                >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column label="年款">
                    <template slot-scope="{row}">
                      <span>{{ row.ModelYear }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="车型">
                    <template slot-scope="{row}">
                      <span>{{ row.Cn==""?row.En: row.Cn}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="档次版本">
                    <template slot-scope="{row}">
                      <span>{{ row.LevelVer }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="档位类型">
                    <template slot-scope="{row}">
                      <span>{{ row.GearType }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="排量版本">
                    <template slot-scope="{row}">
                      <span>{{ row.EmissionVer }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="品牌">
                    <template slot-scope="{row}">
                      <span>{{ row.BrandCn==""?row.BrandEn:row.BrandCn }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="供应商" name="suppliers_pane">
          <el-form :inline="true" :model="suppliersTemp" @submit.native.prevent>
            <el-form-item label="名称">
              <el-input v-model="suppliersTemp.name" size="small"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="getSuppliersList">查找</el-button>
            </el-form-item>
          </el-form>
          <el-row :gutter="20">
            <el-col :span="11">
              <div style="padding-bottom:5px;height:19px;">
                <label></label>
              </div>
              <el-table
                ref="suppliersTable"
                v-loading="listLoading"
                :data="suppliersList"
                border=""
                fit
                highlight-current-row
                @selection-change="supplierLeftSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="供应商">
                  <template slot-scope="{row}">
                    <span>{{ row.Name }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="1" style="text-align:center;margin-top: 35px;">
              <el-button
                type="primary"
                :disabled="!suppliersData.length"
                icon="el-icon-arrow-right"
                size="small"
                circle
                @click="addSuppliers()"
              ></el-button>
              <el-button
                type="primary"
                :disabled="!selectedSuppliersData.length"
                icon="el-icon-arrow-left"
                circle
                style="margin-left: 0;margin-top: 10px;"
                size="small"
                @click="removeSuppliers()"
              ></el-button>
            </el-col>
            <el-col :span="11">
              <div style="padding-bottom:5px;color:#909399;text-align:right;">
                <label>已选择供应商</label>
              </div>
              <el-table
                ref="selectedSuppliersTable"
                :data="selectedSuppliersList"
                border=""
                fit
                highlight-current-row
                @selection-change="supplierRightSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="供应商">
                  <template slot-scope="{row}">
                    <span>{{ row.Name }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="配件产地" name="origins_pane">
          <div style="margin-bottom:10px">
            <el-button size="small" type="primary" @click="addRow()">新增</el-button>
            <el-button size="small" @click="delSelectedOrigins()">删除</el-button>
          </div>
          <el-table
            :data="OriginsTableData"
            refs="OriginsTable"
            border=""
            :row-style="{height:'40px'}"
            @selection-change="handleSelectionChange"
          >>
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="name" label="产地名">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.sel"
                  size="small"
                  v-model="OriginsEditValue"
                  placeholder="产地名"
                ></el-input>
                <span v-else>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  v-if="scope.row.sel"
                  @click.stop="handleOriginSave(scope.$index, scope.row)"
                >保存</el-button>
                <el-button
                  type="text"
                  size="small"
                  @click.stop="handleOriginCancel(scope.$index, scope.row)"
                  v-if="scope.row.sel"
                >取消</el-button>
                <el-button
                  @click.stop="handleOriginEdit(scope.$index, scope.row)"
                  type="text"
                  size="mini"
                  v-if="scope.row.sel==false"
                >编辑</el-button>
                <el-button
                  @click.stop="handleOriginDelete(scope.$index, scope.row)"
                  type="text"
                  size="mini"
                  v-if="scope.row.sel==false"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="上传图片" name="img_pane">
          <el-row>
            <el-col :span="4">
              <el-form-item label="汽配主图">
                <el-upload
                  ref="publicUrl"
                  class="avatar-uploader"
                  :data="{
                          key: 'autoParts/PublicUrl',
                          isPrivate: false
                         }"
                  :action="uploadurl"
                  :show-file-list="false"
                  :on-success="handlePublicUrlSuccess"
                  :before-upload="beforeImgUpload"
                >
                  <img v-if="publicImg" :src="publicImg" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="私有图片">
                <el-upload
                  ref="privateUrl"
                  class="avatar-uploader"
                  :data="{
                          key: 'autoParts/PrivateUrl',
                          isPrivate: true
                        }"
                  :action="uploadurl"
                  :show-file-list="false"
                  :on-success="handlePrivateUrlSuccess"
                  :before-upload="beforeImgUpload"
                >
                  <img v-if="privateImg" :src="privateImg" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="细节图片">
            <el-upload
              ref="detailUrl"
              list-type="picture-card"
              :action="uploadurl"
              :data="{
                        key: 'autoParts/PublicUrl',
                        isPrivate: false
                    }"
              :on-remove="handleRemove"
              :on-success="handleDetailUrlSuccess"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <div style="text-align:right;margin-top:20px;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "apDialogContent",
  data() {
    return {
      uploadurl: "/api/Common/UploadSingle",
      publicImg: "",
      privateImg: "",
      dialogImageUrl: "",
      dialogVisible: false,

      autoPartsformData: {
        Code: "",
        Cn: "",
        En: "",
        ChangeCode: "",
        VehicleDesc: "",
        PrivateUrl: "",
        PublicUrl: "",
        Alias: "",
        Unit: "",
        Size: "",
        Weight: "",
        DurationAdvice: "",
        KilometerAdvice: "",
        Memo: "",
        ApBrands: [],
        AutoSeries: [],
        Suppliers: [],
        Origins: [],
        AutoPartImages: []
      },

      rules: {
        Cn: [{ required: true, message: "请输入配件名称", trigger: "blur" }],
        Code: [{ required: true, message: "请输入配件编码", trigger: "blur" }],
        VehicleDesc: [
          { required: true, message: "请输入适用车型", trigger: "blur" }
        ],
        DurationAdvice: [
          {
            required: false,
            validator: function(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("请输入有效数字"));
              }
            },
            trigger: "blur"
          }
        ],
        KilometerAdvice: [
          {
            required: false,
            validator: function(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("请输入有效数字"));
              }
            },
            trigger: "blur"
          }
        ],
        Weight: [
          {
            required: false,
            validator: function(rule, value, callback) {
              if (Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("请输入有效数字"));
              }
            },
            trigger: "blur"
          }
        ]
      },

      activeName: "brands_pane", //Tabs标签页所处页面

      //汽配件产地值列表
      OriginsTableData: [
        {
          id: 1,
          name: "",
          sel: false //是否选中编辑中
        }
      ],
      OriginsEditValue: "", //产地编辑对象值
      originsSelection: [], //用于存储选中行数据的集合

      listLoading: false,
      brandsTemp: {
        name: ""
      },
      brandsList: [], //查询得到的品牌列表数据
      selectedbrandsList: [], //已选择的品牌列表数据
      brandsData: [], //左边选中的品牌数据
      selectedbrandsData: [], //右边边选中的品牌数据
      //供应商查询条件
      suppliersTemp: {
        name: ""
      },
      suppliersList: [], //查询得到的供应商列表数据
      selectedSuppliersList: [], //已选择的供应商列表数据
      suppliersData: [], //左边选中的供应商数据
      selectedSuppliersData: [], //右边边选中的供应商数据

      //车系查询条件
      autoSeriesTemp: {
        s_num: undefined, //车型年款
        e_num: undefined, //车型年款
        name: "",
        totalCount: 0, //查询结果总数
        currentPage: 1 //分页控件当前页码
      },
      autoSeriesList: [], //查询得到的车系列表数据
      selectedAutoSeriesList: [], //已选择的车系列表数据
      autoSeriesData: [], //左边选中的车系数据
      selectedAutoSeriesData: [] //右边边选中的车系数据
    };
  },
  methods: {
    // <!-----------------------配件品牌------------------------------------->
    //获取品牌列表
    getBrandsList() {
      let searchval = this.brandsTemp.name.trim();
      if (!searchval || searchval == "") {
        this.$util.warningMsg("请输入品牌名称！");
        return;
      }
      this.listLoading = true;
      this.axios
        .get("/AutoParts/GetAutoPartsBrandsByBName?", {
          params: {
            name: searchval
          },
          data: {}
        })
        .then(response => {
          this.listLoading = false;
          this.brandsList = response.data.data;
        })
        .catch(error => {
          this.listLoading = false;
          console.log(error);
        });
    },
    //品牌左边选择事件
    brandLeftSelectionChange(val) {
      this.brandsData = val;
    },
    //品牌右边选择事件
    brandRightSelectionChange(val) {
      this.selectedbrandsData = val;
    },
    //添加选中的品牌
    addBrands() {
      this.brandsData.forEach(sel => {
        let exit = false;
        this.selectedbrandsList.forEach((row, index) => {
          if (sel.Id == row.Id) {
            exit = true;
            return;
          }
        });
        if (!exit) {
          this.selectedbrandsList.push(sel);
        }
      });
    },
    //移除选中的品牌
    removeBrands() {
      this.selectedbrandsData.forEach(sel => {
        this.selectedbrandsList.forEach((row, index) => {
          if (sel.Id == row.Id) {
            this.selectedbrandsList.splice(index, 1);
          }
        });
      });
    },
    // <!-----------------------配件车系------------------------------------->
    //获取车系列表
    getAutoSeriesList(page) {
      let searchval = this.autoSeriesTemp.name.trim();
      if (!searchval || searchval == "") {
        this.$util.warningMsg("请输入查询条件！");
        return;
      }
      // this.autoSeriesTemp.currentPage = page;
      this.listLoading = true;
      this.axios
        .get("/AutoParts/SearchAutoSeriesList", {
          params: {
            key: searchval,
            s_ymodel: this.autoSeriesTemp.s_num,
            e_ymodel: this.autoSeriesTemp.e_num,
            page: page,
            limit: 10
          },
          data: {}
        })
        .then(response => {
          this.listLoading = false;
          // this.autoSeriesList = response.data.data;
          var res = JSON.parse(response.data.data);
          this.autoSeriesTemp.totalCount = res.count;
          this.autoSeriesList = res.data.data;
        })
        .catch(error => {
          this.listLoading = false;
          console.log(error);
        });
    },
    //车系左边选择事件
    autoSeriesLeftSelectionChange(val) {
      this.autoSeriesData = val;
    },
    //车系右边选择事件
    autoSeriesRightSelectionChange(val) {
      this.selectedAutoSeriesData = val;
    },
    //添加选中的车系
    addAutoSeries() {
      this.autoSeriesData.forEach(sel => {
        let exit = false;
        this.selectedAutoSeriesList.forEach((row, index) => {
          if (sel.Id == row.Id) {
            exit = true;
            return;
          }
        });
        if (!exit) {
          this.selectedAutoSeriesList.push(sel);
        }
      });
    },
    //移除选中的车系
    removeAutoSeries() {
      this.selectedAutoSeriesData.forEach(sel => {
        this.selectedAutoSeriesList.forEach((row, index) => {
          if (sel.Id == row.Id) {
            this.selectedAutoSeriesList.splice(index, 1);
          }
        });
      });
    },
    // <!-----------------------供应商------------------------------------->
    getSuppliersList() {
      let searchval = this.suppliersTemp.name.trim();
      if (!searchval || searchval == "") {
        this.$util.warningMsg("请输入供应商名称！");
        return;
      }
      this.listLoading = true;
      this.axios
        .get("/AutoParts/GetAutoPartsSuppliesByName?", {
          params: {
            name: searchval
          },
          data: {}
        })
        .then(response => {
          this.listLoading = false;
          this.suppliersList = response.data.data;
        })
        .catch(error => {
          this.listLoading = false;
          console.log(error);
        });
    },
    //供应商左边选择事件
    supplierLeftSelectionChange(val) {
      this.suppliersData = val;
    },
    //供应商右边选择事件
    supplierRightSelectionChange(val) {
      this.selectedSuppliersData = val;
    },
    //添加选中的供应商
    addSuppliers() {
      this.suppliersData.forEach(sel => {
        let exit = false;
        this.selectedSuppliersList.forEach((row, index) => {
          if (sel.Id == row.Id) {
            exit = true;
            return;
          }
        });
        if (!exit) {
          this.selectedSuppliersList.push(sel);
        }
      });
    },
    //移除选中的供应商
    removeSuppliers() {
      this.selectedSuppliersData.forEach(sel => {
        this.selectedSuppliersList.forEach((row, index) => {
          if (sel.Id == row.Id) {
            this.selectedSuppliersList.splice(index, 1);
          }
        });
      });
    },
    // <!-----------------------配件产地------------------------------------->
    // 增加行
    addRow() {
      for (let item of this.OriginsTableData) {
        if (item.sel) {
          this.$util.warningMsg("请先保存正在编辑中的产地！！");
          return;
        }
      }
      this.OriginsEditValue = "";
      var row = {
        id: this.OriginsTableData.length + 1,
        name: "",
        sel: true
      };
      this.OriginsTableData.push(row);
    },
    //删除选中的汽配件产地
    delSelectedOrigins() {
      for (let item of this.OriginsTableData) {
        if (item.sel) {
          this.$util.warningMsg("请先保存正在编辑中的产地！！");
          return;
        }
      }
      if (this.originsSelection.length == 0) {
        this.$util.warningMsg("请选择产地！！");
        return;
      }
      this.originsSelection.forEach(sel => {
        this.OriginsTableData.forEach((row, index) => {
          if (sel.name == row.name) {
            this.OriginsTableData.splice(index, 1);
          }
        });
      });
    },
    //选中产地
    handleSelectionChange(val) {
      this.originsSelection = val;
    },
    //汽配件产地编辑事件
    handleOriginEdit(index, row) {
      for (let item of this.OriginsTableData) {
        if (item.sel) return;
      }
      this.OriginsEditValue = row.name;
      row.sel = true;
    },
    //汽配件产地保存事件
    handleOriginSave(index, row) {
      if (this.OriginsEditValue.length == 0) {
        this.$util.warningMsg("产地名称不能为空！！");
        return;
      }
      for (let item of this.OriginsTableData) {
        if (item.id != row.id && item.name == this.OriginsEditValue) {
          this.$util.warningMsg("该产地已存在！！");
          return;
        }
      }
      row.name = this.OriginsEditValue;
      row.sel = false;
    },
    //汽配件产地取消事件
    handleOriginCancel(index, row) {
      row.sel = false;
    },
    //汽配件产地删除事件
    handleOriginDelete(index, row) {
      for (let item of this.OriginsTableData) {
        if (item.sel) return;
      }
      this.OriginsTableData.splice(index, 1);
      // row.splice(index, 1);
    },
    //汽配件主图片上传成功回调
    handlePublicUrlSuccess(res, file) {
      if (res.errcode === 0) {
        this.autoPartsformData.PublicUrl = res.fileUrl;
        this.publicImg = URL.createObjectURL(file.raw);
      } else {
        this.$util.warningMsg("图片上传失败！！");
        this.publicImg = "";
        this.autoPartsformData.PublicUrl = "";
        this.$refs.publicUrl.clearFiles();
      }
    },
    //汽配件私有图片上传成功回调
    handlePrivateUrlSuccess(res, file) {
      if (res.errcode === 0) {
        this.autoPartsformData.PrivateUrl = res.fileUrl;
        this.privateImg = URL.createObjectURL(file.raw);
      } else {
        this.$util.warningMsg("图片上传失败！！");
        this.autoPartsformData.PrivateUrl = "";
        this.privateImg = "";
        this.$refs.privateUrl.clearFiles();
      }
    },
    //汽配件细节图片上传成功回调
    handleDetailUrlSuccess(res, file, fileList) {
      if (res.errcode === 0) {
        this.autoPartsformData.AutoPartImages.push(res.fileUrl);
      } else {
        this.$util.warningMsg("图片上传失败！！");
      }
    },
    //图片上传前检验是否符合规格
    beforeImgUpload(file) {
      return this.$util.uploadCheck(file);
    },
    //细节图片移除
    handleRemove(file, fileList) {
      let that = this;
      let autoPartImages = that.autoPartsformData.AutoPartImages;
      autoPartImages.splice(autoPartImages.indexOf(file.response.fileUrl), 1);
      this.autoPartsformData.AutoPartImages = autoPartImages;
    },
    // //细节图片预览
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    //提交汽配件数据
    submitForm() {
      let that = this;
      this.$refs.autoPartsform.validate(vaild => {
        if (vaild) {
          if (that.autoPartsformData.Weight == "") {
            that.autoPartsformData.Weight = 0;
          }
          if (that.autoPartsformData.DurationAdvice == "") {
            that.autoPartsformData.DurationAdvice = 0;
          }
          if (that.autoPartsformData.KilometerAdvice == "") {
            that.autoPartsformData.KilometerAdvice = 0;
          }

          //品牌数据
          that.selectedbrandsList.forEach(row => {
            that.autoPartsformData.ApBrands.push(row.Id);
          });
          //车型数据
          that.selectedAutoSeriesList.forEach(row => {
            that.autoPartsformData.AutoSeries.push({
              AutoSeriesId: row.Id,
              AutoSerieName: row.Cn != "" ? row.Cn : row.En
            });
          });
          //供应商数据
          that.selectedSuppliersList.forEach(row => {
            that.autoPartsformData.Suppliers.push(row.Id);
          });
          //产地数据
          that.OriginsTableData.forEach(row => {
            if (row.name.length > 0) {
              that.autoPartsformData.Origins.push(row.name);
            }
          });
          this.axios
            .post("/AutoParts/AddAutoPart", that.autoPartsformData)
            .then(res => {
              var data = res.data.data;
              if (res.data.errcode == 0 && data) {
                that.autoPartsformData.ApBrands = [];
                that.autoPartsformData.AutoSeries = [];
                that.autoPartsformData.Suppliers = [];
                that.autoPartsformData.Origins = [];
                that.$util.warningMsg("该编码的配件已存在！！");
                return false;
              }
              that.$util.successMsg("新增配件成功");
              that.closeDialog();
            })
            .catch(error => {
              that.autoPartsformData.ApBrands = [];
              that.autoPartsformData.AutoSeries = [];
              that.autoPartsformData.Suppliers = [];
              that.autoPartsformData.Origins = [];
              that.$message.error("新增配件失败！");
            });
        }
      });
    },
    //重置表单
    resetForm() {
      //清空品牌数据
      this.autoPartsformData.ApBrands = [];
      this.brandsTemp.name = "";
      this.brandsList = [];
      this.selectedbrandsList = [];
      this.brandsData = [];
      this.selectedbrandsData = [];
      // 清空车型数据
      this.autoPartsformData.AutoSeries = [];
      this.autoSeriesTemp = {
        s_num: undefined, //车型年款
        e_num: undefined, //车型年款
        name: "",
        totalCount: 0, //查询结果总数
        currentPage: 1 //分页控件当前页码
      };
      this.autoSeriesList = [];
      this.selectedAutoSeriesList = [];
      this.autoSeriesData = [];
      this.selectedAutoSeriesData = [];
      //清空供应商数据
      this.autoPartsformData.Suppliers = [];
      this.suppliersTemp.name = "";
      this.suppliersList = [];
      this.selectedSuppliersList = [];
      this.suppliersData = [];
      this.selectedSuppliersData = [];
      //清空产地与细节图片
      this.autoPartsformData.Origins = [];
      this.autoPartsformData.AutoPartImages = [];
      //重置产地表格数据
      this.OriginsTableData = [{ id: 1, name: "", sel: false }];
      //重置图片数据
      this.publicImg = "";
      this.$refs.publicUrl.clearFiles();
      this.privateImg = "";
      this.$refs.privateUrl.clearFiles();
      this.$refs.detailUrl.clearFiles();
      if (this.$refs["autoPartsform"] != undefined) {
        this.$refs["autoPartsform"].resetFields();
      }

      this.activeName = "brands_pane";
    },
    //关闭弹窗
    closeDialog() {
      this.resetForm();
      this.$emit("controlApDialogVisible", false);
    }
  }
};
</script>


<style lang="less" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.avatar {
  width: 148px;
  height: 148px;
  display: block;
}

.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.el-table__body tr,
.el-table__body td {
  padding: 0;
  height: 40px;
}
</style>
